"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
var CustomViewImpl_1 = require("../../Impl/CustomViewImpl");
var ServiceImplBase_1 = require("./ServiceImplBase");
var VizServiceImpl = /** @class */ (function (_super) {
    __extends(VizServiceImpl, _super);
    function VizServiceImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(VizServiceImpl.prototype, "serviceName", {
        get: function () {
            return "viz-service" /* Viz */;
        },
        enumerable: true,
        configurable: true
    });
    VizServiceImpl.prototype.createVizImageAsync = function (inputSpec) {
        var _a;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'createVizImageAsync',
            _a[api_internal_contract_js_1.ParameterId.VizAPIInputJson] = JSON.stringify(inputSpec),
            _a);
        return this.execute(api_internal_contract_js_1.VerbId.VizAPI, parameters).then(function (response) {
            var result = response.result;
            return result;
        });
    };
    VizServiceImpl.prototype.activateSheetAsync = function (name) {
        var _a;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'activateSheetAsync',
            _a[api_internal_contract_js_1.ParameterId.SwitchToSheetName] = name,
            _a);
        return this.execute(api_internal_contract_js_1.VerbId.ActivateSheet, parameters).then(function () {
            return;
        });
    };
    VizServiceImpl.prototype.getCustomViewsAsync = function () {
        var _a;
        var _this = this;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'getCustomViewsAsync',
            _a);
        return this.execute(api_internal_contract_js_1.VerbId.GetCustomViews, parameters).then(function (response) {
            var customViews = response.result;
            return customViews.map(function (customView) {
                return new CustomViewImpl_1.CustomViewImpl(customView, _this._registryId);
            });
        });
    };
    VizServiceImpl.prototype.showCustomViewAsync = function (customViewName) {
        var _a;
        var _this = this;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'showCustomViewAsync',
            _a[api_internal_contract_js_1.ParameterId.CustomViewName] = customViewName || '',
            _a);
        return this.execute(api_internal_contract_js_1.VerbId.ShowCustomView, parameters).then(function (response) {
            var _a;
            var customView = response.result;
            return ((_a = customView) === null || _a === void 0 ? void 0 : _a.luid) ? new CustomViewImpl_1.CustomViewImpl(customView, _this._registryId) : undefined;
        });
    };
    VizServiceImpl.prototype.removeCustomViewAsync = function (customViewName) {
        var _a;
        var _this = this;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'removeCustomViewAsync',
            _a[api_internal_contract_js_1.ParameterId.CustomViewName] = customViewName,
            _a);
        return this.execute(api_internal_contract_js_1.VerbId.RemoveCustomView, parameters).then(function (response) {
            var customView = response.result;
            return new CustomViewImpl_1.CustomViewImpl(customView, _this._registryId);
        });
    };
    VizServiceImpl.prototype.saveCustomViewAsync = function (customViewName) {
        var _a;
        var _this = this;
        // CustomViewIsDefault is a required parameter, but our API has not been updated to allow it to be specified yet.
        // We should add a 'default' parameter to the interface.
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'saveCustomViewAsync',
            _a[api_internal_contract_js_1.ParameterId.CustomViewName] = customViewName,
            _a[api_internal_contract_js_1.ParameterId.CustomViewIsDefault] = false,
            _a);
        return this.execute(api_internal_contract_js_1.VerbId.SaveWorkbookAsCustomView, parameters).then(function (response) {
            var customView = response.result;
            return new CustomViewImpl_1.CustomViewImpl(customView, _this._registryId);
        });
    };
    VizServiceImpl.prototype.setActiveCustomViewAsDefaultAsync = function () {
        var _a;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'setActiveCustomViewAsDefaultAsync',
            _a);
        return this.execute(api_internal_contract_js_1.VerbId.SetActiveCustomViewAsDefault, parameters).then(function () {
            return;
        });
    };
    VizServiceImpl.prototype.saveAsync = function (customView) {
        var _a;
        var _this = this;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'saveAsync',
            _a[api_internal_contract_js_1.ParameterId.CustomViewLuid] = customView.luid,
            _a[api_internal_contract_js_1.ParameterId.CustomViewName] = customView.name,
            _a[api_internal_contract_js_1.ParameterId.CustomViewIsDefault] = customView.isDefault,
            _a[api_internal_contract_js_1.ParameterId.CustomViewIsPublic] = customView.shared,
            _a);
        return this.execute(api_internal_contract_js_1.VerbId.UpdateCustomView, parameters).then(function (response) {
            var customView = response.result;
            return new CustomViewImpl_1.CustomViewImpl(customView, _this._registryId);
        });
    };
    VizServiceImpl.prototype.getCurrentSrcAsync = function () {
        var _a;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'getCurrentSrcAsync',
            _a);
        return this.execute(api_internal_contract_js_1.VerbId.GetCurrentSrc, parameters).then(function (response) { return response.result; });
    };
    return VizServiceImpl;
}(ServiceImplBase_1.ServiceImplBase));
exports.VizServiceImpl = VizServiceImpl;
//# sourceMappingURL=VizServiceImpl.js.map